<template>
  <a-modal
    :visible="visible"
    title="Póliza con ticket pendiente"
    centered
    :footer="null"
    :maskClosable="false"
    destroyOnClose
    width="600px"
    @cancel="close"
  >
    <a-typography-text>
      Ya existe un ticket de
      <b>{{ ticketTypeLabel || 'baja' }}</b>
      pendiente
      <template v-if="employeeRut">para el titular {{ employeeRut }}</template>
      para las siguientes póliza(s).
    </a-typography-text>

    <a-table
      row-key="id"
      size="small"
      class="mt-3"
      :columns="columns"
      :data-source="conflicts"
      :pagination="false"
      :scroll="{ y: 240 }"
    >
      <template #action="{ record }">
        <a-button type="link" size="small" @click="goToTicket(record)">
          Ver ticket
        </a-button>
      </template>
    </a-table>

    <div class="text-right mt-3">
      <a-button @click="close">Cerrar</a-button>
    </div>
  </a-modal>
</template>

<script>
import { computed } from 'vue';
import { useRouter } from 'vue-router';

export default {
  name: 'PendingPolicyModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    conflicts: {
      type: Array,
      default: () => []
    },
    ticketRouteName: {
      type: String,
      required: true
    },
    ticketTypeLabel: {
      type: String,
      default: ''
    },
    employeeRut: {
      type: String,
      default: ''
    }
  },
  emits: ['update:visible'],
  setup(props, { emit }) {
    const router = useRouter();

    const columns = computed(() => {
      const base = [
        { title: 'Póliza', dataIndex: 'policy', key: 'policy' },
        { title: 'Ticket', dataIndex: 'ticketId', key: 'ticketId' }
      ];
      const hasDependentRut = props.conflicts?.some((c) => c.dependentRut);
      if (hasDependentRut) {
        base.splice(1, 0, {
          title: 'Carga',
          dataIndex: 'dependentRut',
          key: 'dependentRut'
        });
      }
      base.push({
        title: 'Acción',
        key: 'action',
        slots: { customRender: 'action' }
      });
      return base;
    });

    const close = () => {
      emit('update:visible', false);
    };

    const goToTicket = (record) => {
      router.push({
        name: props.ticketRouteName,
        params: { id: record.ticketId }
      });
    };

    return {
      columns,
      close,
      goToTicket
    };
  }
};
</script>
